import { atom } from 'recoil';
import { WidgetConfigState } from '../types/widgetConfigState';

export const widgetStateAtom = atom<WidgetConfigState>({
  key: 'widget',
  default: undefined,
});
